import OrgTree from './Org/OrgTree.vue'
OrgTree.install = function (Vue) {
  Vue.component(OrgTree.name, OrgTree)
}
export {
  OrgTree
}
